import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["results"]

    connect() {
        this.projects = JSON.parse(this.element.dataset.projects || "[]")
    }

    filter(event) {
        const pathPrefix = this.element.dataset.pathPrefix
        
        const query = event.target.value.trim().toLowerCase()
        this.resultsTarget.innerHTML = ""

        if (query.length < 2) {
            this.resultsTarget.classList.add("d-none")
            return
        }

        this.resultsTarget.classList.remove("d-none")
        const matches = this.projects.filter(p => p.name.toLowerCase().includes(query))
        matches.forEach(project => {
          const li = document.createElement("li")
          li.className = "list-group-item"
        
          const a = document.createElement("a")
          a.href = `${pathPrefix}?project_slug=${project.slug}`
          a.textContent = project.name
        
          li.appendChild(a)
          this.resultsTarget.appendChild(li)
        })
    }

    clearInput() {
        const pathPrefix = this.element.dataset.pathPrefix
        window.location.href = pathPrefix
        
  }
}